import React, { useState } from "react";
import { LogIn, Lock } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { BackgroundSlideshow } from "./BackgroundSlideshow";
import { isAuthed, login } from "../lib/auth";

export const LoginGate = ({ children }) => {
  const [authed, setAuthed] = useState(isAuthed());
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  if (authed) return children;

  const submit = (e) => {
    e.preventDefault();
    if (login(userId, password)) {
      setAuthed(true);
    } else {
      setError("गलत यूज़र आईडी या पासवर्ड");
    }
  };

  return (
    <div className="min-h-screen grid place-items-center relative px-4">
      <BackgroundSlideshow />
      <form
        onSubmit={submit}
        data-testid="login-form"
        className="relative z-10 w-full max-w-sm card-3d bg-[#fffdf7] border border-[#cdb98f] rounded-2xl p-7 animate-fade-up"
      >
        <div className="flex flex-col items-center text-center mb-5">
          <div className="w-14 h-14 grid place-items-center leading-none font-cinzel font-extrabold text-[#f3ead6] bg-[#5e1414] border-2 border-[#7a1f1f] rounded-lg shadow-[0_3px_10px_rgba(94,20,20,0.4)] text-lg">
            <span>RS</span>
            <span>SB</span>
          </div>
          <h1 className="mt-3 font-cinzel text-xl font-extrabold text-[#5e1414] uppercase tracking-wide">
            Radha Soami Satsang Beas
          </h1>
          <p className="text-xs text-[#7a4a3a] font-dev mt-1">सत्संग शेड्यूल प्लानर — लॉगिन करें</p>
        </div>

        <div className="space-y-3">
          <div>
            <Label className="text-[#5a2a24] font-dev">यूज़र आईडी</Label>
            <Input
              data-testid="login-userid"
              value={userId}
              onChange={(e) => {
                setUserId(e.target.value);
                setError("");
              }}
              placeholder="admin@sukh"
              autoCapitalize="none"
              autoCorrect="off"
              autoComplete="username"
              spellCheck={false}
              className="mt-1 bg-[#f6eeda] border-[#cdb98f] text-[#3a1212]"
            />
          </div>
          <div>
            <Label className="text-[#5a2a24] font-dev">पासवर्ड</Label>
            <Input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              placeholder="••••••••"
              autoCapitalize="none"
              autoCorrect="off"
              autoComplete="current-password"
              spellCheck={false}
              className="mt-1 bg-[#f6eeda] border-[#cdb98f] text-[#3a1212]"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-sm text-[#b91c1c] font-dev flex items-center gap-1">
              <Lock className="w-3.5 h-3.5" /> {error}
            </p>
          )}
          <Button
            type="submit"
            data-testid="login-submit"
            className="w-full bg-gradient-to-b from-[#7a1f1f] to-[#5e1414] border border-[#431010] text-[#f3ead6] font-bold gap-2 btn-3d-red mt-1"
          >
            <LogIn className="w-4 h-4" /> लॉगिन
          </Button>
        </div>
      </form>
    </div>
  );
};
